export { default as loginWallpage } from "./loginWallpage.png"
export { default as registerWallpage } from "./registerWallpage.png"
export { default as tokenWallpage } from "./tokenWallpage.png"
export { default as paymentSuccessWallpage } from "./paymentSuccessWallpage.png"
export { default as paymentFailWallpage } from "./paymentFailWallpage.png"
export { default as centerIDLogo } from "./centerIDLogo.png"
export { default as dollar } from "./dollar.png"
export { default as date } from "./date.png"
export { default as user } from "./user.png"
